// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_eS","advertDetailHeaderPrice__value":"c-m_eT","advertDetailHeaderPrice__label":"c-m_eU"};